export const spotlight = Object.freeze({
  BUSINESS_ACCOUNT: 'business_account'
})

export default spotlight
